


























import { Vue, Component,Prop,Watch } from 'vue-property-decorator';

@Component
export default class HoriScroll extends Vue {
    @Prop({default:''})    
    public val:string
    @Prop({default:false})
    public rst:boolean
    @Prop()
    public resets:boolean
    public timer:any = null;
    public text:any = ''

    @Watch('resets')
    resetsChange(val){
        console.log('resets->',val);
    }
    @Watch('rst',{deep:true})
    rstChange(val){
        console.log('rst-->',val);
        // if(val){
        //     console.log('重置');           
        //     let copy = document.querySelector('.copy') as any
        //     copy.innerText = '';
        //     this.text = '';
        //     this.text = this.val;
        //     this.reset();
        //     this.start();
        // }
    }
    @Watch('val')
    valChange(val){
        console.log('val-change',val);
        this.reset();
        let copy = document.querySelector('.copy') as any
        copy.innerText = ''
        this.text = '';
        this.text = this.val;
        
        this.start();
    }
    public created(){
        console.log('created-->',this.val);
        this.text = this.val;
        this.start();        
    }
    public mounted(){
        console.log('mounted-->',this.val);
    }
    public start(){
         let timer = setTimeout(() => {
            console.log('gotostart--->');
            this.move()
            clearTimeout(timer)
        }, 1000)
    }
    public reset(){
        if(this.timer){
            clearInterval(this.timer)
            this.timer = null;
        } 
        let scroll = document.querySelector('.scroll');
        (scroll as any).style.transform = '';
    }
    public move () {
      let maxWidth = document.querySelector('.marquee-wrap').clientWidth
      let width = document.querySelector('.getWidth').scrollWidth
      console.log('move-->',width <= maxWidth);
      if (width <= maxWidth) return
      let scroll = document.querySelector('.scroll')
      let copy = document.querySelector('.copy') as any
      copy.innerText = this.text
      if(this.timer){
        clearInterval(this.timer);
        this.timer = null;
      }
      let distance = 0 
      this.timer = setInterval(() => {
        distance -= 1
        if (-distance >= width) {
          distance = 16
        }
        (scroll as any).style.transform = 'translateX(' + distance + 'px)'
      }, 20)
    }
    beforeDestroy () {
        if(this.timer){
          clearInterval(this.timer)
        }        
    }
}
